import DashboardComponentsSidebarAddWidgets from '@/modules/dashboard-module/components/sidebar-add-widgets/dashboard-components-sidebar-add-widgets.vue'
import DashboardComponentsSidebarAddWidgetsComp from '@/modules/dashboard-module/components/sidebar-add-widgets/dashboard-components-sidebar-add-widgets'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Ref } from 'vue-property-decorator'
import { UserInformationDetailResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { store } from '@/store/store'
import moment from 'moment'
import { DateUtils } from '@/shared/util/date-utils'

@Component({
    components: {
        DashboardComponentsSidebarAddWidgets
    }
})
export default class DashboardViewsHeaderArea extends Vue {
    @Ref() readonly dashboardComponentsSidebarAddWidgets!: DashboardComponentsSidebarAddWidgetsComp

    get userInformation(): UserInformationDetailResponse {
        return store.getters.userInformation
    }

    get greatingUser(): string {
        return `${this.greating}, ${this.userName}`
    }

    get userName() {
        if (this.userInformation) {
            if (this.userInformation.petitioner) {
                return [this.userInformation.petitioner.name,
                    this.userInformation.petitioner.middleName,
                    this.userInformation.petitioner.surname1,
                    this.userInformation.petitioner.surname2].join(' ')
            }
            if (this.userInformation.personnel) {
                return [this.userInformation.personnel.name,
                    this.userInformation.personnel.middleName,
                    this.userInformation.personnel.surname1,
                    this.userInformation.personnel.surname2].join(' ')
            }
        }
        return ''
    }

    get greating(): string {
        const currentMoment = moment()

        if (!currentMoment || !currentMoment.isValid()) {
            return ''
        }

        let splitAfternoon = 12
        let splitEvening = 20
        let currentHour = parseFloat(currentMoment.format('HH'))

        if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
            return this.$tc('global.greetingEvening')
        } else if (currentHour >= splitEvening) {
            return this.$tc('global.greetingNight')
        } else {
            return this.$tc('global.greetingMorning')
        }
    }

    get currentDate(): string {
        return moment(new Date()).format(DateUtils.localeDatePatternWithText)
    }

    showSidepanelToAddWidgets(): void {
        this.dashboardComponentsSidebarAddWidgets.show()
    }
}
